import ClientProfile from './Profile';

export default ClientProfile;
